import { render, staticRenderFns } from "./AvaliacaoManual.vue?vue&type=template&id=080194fe&scoped=true&"
import script from "./AvaliacaoManual.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoManual.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacaoManual.vue?vue&type=style&index=0&id=080194fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080194fe",
  null
  
)

export default component.exports